// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"listWrapper_wrapper__2DbvR"};